module.exports = __webpack_public_path__ + "static/img/20.f495bc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/20.jpg
// module id = YYzr
// module chunks = 0